import { render, staticRenderFns } from "./createBKNewFamily.vue?vue&type=template&id=e33df1f8&scoped=true"
import script from "./createBKNewFamily.vue?vue&type=script&lang=js"
export * from "./createBKNewFamily.vue?vue&type=script&lang=js"
import style0 from "./createBKNewFamily.vue?vue&type=style&index=0&id=e33df1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33df1f8",
  null
  
)

export default component.exports